import { render, staticRenderFns } from "./Step2Password.vue?vue&type=template&id=0c63c788"
import script from "./Step2Password.vue?vue&type=script&lang=ts"
export * from "./Step2Password.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports